export const state = () =>  {
  return {
    reportColumns: [],

    selection: [],
    showSitesFilter: false,
    showSourcesFilter: false,
    showMarketFilter: false,
    showSubSourceFilter: false,
    showDeviceFilter: false,
    showCCStatusDisplayFilter: false,
    isBaseDataLoaded: false,

    isNeedToUpdate: false,
    isNeedToUpdateChart: false,
    loadingStatus: 1, // set loading by default
    paginationLimit: 50,
    pagination: {
      cursor: null,
      direction: null
    },
    searchPhrase: null,
    presetUpdated: false,
    dateComparisonStatus: false,

    filters: {},
    advancedFilters: {},
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/baseReport/filter/state.js